import { createFileRoute } from '@tanstack/react-router';

import { CreateEnquiryPage } from '../order/create-enquiry/CreateEnquiryPage';

export const Route = createFileRoute('/_app/orders_/new')({
    component: CreateEnquiryPage,
});
